import { render } from "./LoadOrderEdit.vue?vue&type=template&id=39089e5c&scoped=true"
import script from "./LoadOrderEdit.vue?vue&type=script&lang=js"
export * from "./LoadOrderEdit.vue?vue&type=script&lang=js"

import "./LoadOrderEdit.vue?vue&type=style&index=0&id=39089e5c&scoped=true&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39089e5c"]])

export default __exports__